import { render, staticRenderFns } from "./DgaServices.handler.vue?vue&type=template&id=43d70d9a&"
import script from "./DgaServices.handler.vue?vue&type=script&lang=ts&"
export * from "./DgaServices.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports